import React from 'react';
import { KpiStatCard } from 'pages/ReportsPage/components/AnalyticsDashboards/KpiStatCard';
import { KpiStatCardRowProps } from 'pages/ReportsPage/components/AnalyticsDashboards/KpiStatCardRow/KpiStatCardRow.types';
import {
  StatCardRowContainer,
  StatCardItem,
} from 'pages/ReportsPage/components/AnalyticsDashboards/KpiStatCardRow/KpiStatCardRow.styled';

export const KpiStatCardRow: React.FC<KpiStatCardRowProps> = ({ cards, fullWidth }) => {
  return (
    <StatCardRowContainer>
      {cards.map((card, index) => (
        <StatCardItem key={index} $fullWidth={fullWidth}>
          <KpiStatCard {...card} />
        </StatCardItem>
      ))}
    </StatCardRowContainer>
  );
};
